import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';
import { KennzahlenButtonWrapper } from './wrapper/KennzahlenButtonWrapper';
import * as React from 'react';
import { renderText } from '../assistent_helpers';

export function getAssistentConfigKennziffern(data: any): AssistentItem {
    const externalDescription = renderText('Betriebliche Daten - Kennzahlen', data, true);
    const eingabe_standorte = {
        gliederung: '6.',
        name: 'Kennzahlen',
        description: 'Dies ist das Formular zur Eingabe der gewerkespezifischen Kennzahlen.',
        type: 'EntityForm',
        entity: IDs.ENT_KENNZIFFERN_GENERATED,
        singleItem: true,
        configFlag: 'inputKennziffern',
        customTopElement: (entity: string, item: any, callback?: (data: any) => void) =>
            <KennzahlenButtonWrapper
                data={data}
            />,
        externalDescriptionElement: externalDescription
    };
    return eingabe_standorte;
}
